import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "Paid Media", desc: "High-intent campaigns across Google and Meta with strict CAC and ROI control." },
  { title: "Performance Creative", desc: "Ad creative systems designed for testing velocity and conversion efficiency." },
  { title: "Funnel Strategy", desc: "Offer, landing page, and retargeting architecture aligned to revenue goals." },
  { title: "Attribution Clarity", desc: "Channel-level reporting that shows what drives pipeline, not vanity metrics." },
  { title: "Conversion Optimization", desc: "A/B testing and UX refinement that compounds every campaign gain." },
  { title: "Growth Sprints", desc: "90-day operating plans with weekly actions and transparent outcome tracking." },
];

const DigitalMarketing = () => (
  <StitchFeaturePage
    label="WEB & DIGITAL"
    title="Marketing that"
    titleAccent="moves revenue."
    subtitle="Precision-led digital marketing execution focused on qualified demand, efficient spend, and predictable growth."
    features={features}
    ctaLabel="SCALE MY GROWTH"
  />
);

export default DigitalMarketing;